import { render, staticRenderFns } from "./ClientUserMove.vue?vue&type=template&id=bebb2508"
import script from "./ClientUserMove.vue?vue&type=script&lang=js"
export * from "./ClientUserMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports